import { ProjectPortfolioGrid } from '../components/ProjectPortfolioGrid'

export function Projects() {
  return (
    <div className="pt-20"> 
      {/* Projects Grid */}
      <ProjectPortfolioGrid />
    </div>
  )
}
